/**
 * Labstep
 *
 * @module components/Group/Action/SetDefaultUserGroupType
 * @desc Set defaultUserGroupType for Group
 */

import { PermissionRoleActionUpdateDropdownPill } from 'labstep-web/components/PermissionRole/Action/UpdateDropdownPill';
import {
  PERMISSION_ROLE_EDITOR,
  PERMISSION_ROLE_OWNER,
  PERMISSION_ROLE_VIEWER,
} from 'labstep-web/constants/roles';
import { PermissionType } from 'labstep-web/models/permission.model';
import type React from 'react';
import type {
  APIResponseBodyProps,
  GroupActionSetDefaultUserGroupTypeProps,
} from './types';

export const GroupActionSetDefaultUserGroupType: React.FC<
  GroupActionSetDefaultUserGroupTypeProps
> = ({ group }) => (
  <PermissionRoleActionUpdateDropdownPill
    entity={group}
    withOwner={false}
    body={(permissionRole) => {
      const body: APIResponseBodyProps = {
        default_user_group_type: PermissionType.edit,
      };
      if (permissionRole.name === PERMISSION_ROLE_OWNER.name) {
        body.default_user_group_type = PermissionType.owner;
      } else if (
        permissionRole.name === PERMISSION_ROLE_VIEWER.name
      ) {
        body.default_user_group_type = PermissionType.view;
      } else if (
        permissionRole.name !== PERMISSION_ROLE_EDITOR.name
      ) {
        body.default_user_group_permission_role_guid =
          permissionRole.guid;
      }
      return body;
    }}
    currentValue={group.defaultPermissionRoleName}
  />
);
